import { OnboardingIdentityDialogComponent } from './components/onboarding-identity-dialog/onboarding-identity-dialog.component';
import { LegalPersonOnboardingComponent } from './components/legal-person-onboarding/legal-person-onboarding.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SDShapesListComponent } from './components/sdshapes-list/sdshapes-list.component';
import { CustomComponentModule } from 'src/app/customModules/app-component-module';
import { CustomMaterialModule } from 'src/app/customModules/app-material-module';
import { FormComponent } from './components/form/form.component';
import { FormFieldComponent } from './components/form/form-field/form-field.component';
import { ErrorComponent } from './utils/error/error.component';
import { LoadingComponent } from './utils/loading/loading.component';
import { DataSpaceRegistrationComponent } from './components/data-space-registration/data-space-registration.component';
import { DidGeneratorModule } from 'src/app/construct-x/did-manager/did-generator.module';
import { SharedModule } from 'src/app/construct-x/shared/shared.module';
import { TablePageComponent } from 'src/app/con-x/table/table-page.component';

@NgModule({
  declarations: [
    LegalPersonOnboardingComponent,
    SDShapesListComponent,
    FormComponent,
    FormFieldComponent,
    ErrorComponent,
    LoadingComponent,
    DataSpaceRegistrationComponent,
  ],
  imports: [
    OnboardingIdentityDialogComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    CustomComponentModule,
    SharedModule,
    DidGeneratorModule,
    TablePageComponent,
  ],
  exports: [
    SDShapesListComponent,
    FormComponent,
    FormFieldComponent,
    ErrorComponent,
    LoadingComponent,
  ],
})
export class DataSpaceComponentModule { }
